



















import Vue from 'vue'
export default Vue.extend({
  name: 'MailboxSettingsAutoForwardingEmail',

  props: {
    email: {
      type: String,
      required: true,
    },
  },
  methods: {
    remove(): void {
      this.$emit('remove', this.email)
    },
  },
})
